import React from "react";
import {
  SelectInput,
  DateInput,
  // TextInput,
  Edit,
  SimpleForm,
  Toolbar,
  SaveButton,
  FormDataConsumer,
  Query
} from "react-admin";

import { required } from "ra-core";
import NestedGrid from "../components/listBikeHistoryGrid";

import { Grid, LinearProgress } from "@material-ui/core";

import { sortBy, compose, prop, head, isEmpty, isNil, curry } from "ramda";

import moment from "moment";
import styled from "styled-components";
const Card = styled.div(props => ({
  padding: "1em",
  backgroundColor: props.color,
  boxShadow: "rgb(245,157,29) 0px 1px 3px, rgb(250,228,195)  0px 1px 2px",
  marginTop: "0.5em"
}));

const buildStructure = (allItems, date1, date2) => {
  const structure = [];
  const mainKeys = Object.keys(allItems);

  mainKeys.map(eventKey => {
    allItems[eventKey].map(event => {
      switch (eventKey) {
        case "rentals":
          if (isBeforeDate1(date1, event) && isAfterDate2(date2, event)) {
            structure.push({
              description: `${event.type === 2 ? "Rental" : "Tour"} ${event.id
                }`,
              title: `${event.booking.r_first_name} ${event.booking.r_last_name}`,
              date1: event.date_1,
              date2: event.date_2,
              location1: event.location_1 ? event.location_1.location_name : "",
              location_id_1: event.location_1 ? event.location_1.id : "",
              cellLocation2Color: "",
              location2: event.location_2.location_name,
              location_id_2: event.location_2 ? event.location_2.id : "",
              bgColor: event.location_1
                ? event.location_1.color
                : event.location_2.color,
              bgColor2: event.location_2
                ? event.location_2.color
                : event.location_1.color,
              key: `${eventKey}_${event.id}`
            });
          }
          break;
        // case "holds":
        //   structure.push({
        //     description: `Hold ${event.id}`,
        //     title: `Hold`,
        //     date1: event.start_date,
        //     date2: event.end_date,
        //     location1: "",
        //     location_id_1: "",
        //     cellLocation2Color: "",
        //     location2: "",
        //     location_id_2: "",
        //     bgColor: "whiteSmoke",
        //     key: `${eventKey}_${event.id}`
        //   });
        //   break;
        case "transfers":
          if (isBeforeDate1(date1, event) && isAfterDate2(date2, event)) {
            structure.push({
              description: `Transfer ${event.id}`,
              title: `Transfer`,
              date1: moment(event.transfer_date).format("YYYY-MM-DD"),
              date2: moment(event.setup_date).format("YYYY-MM-DD"),
              location1: event.location_1 ? event.location_1.location_name : "",
              location_id_1: event.location_1 ? event.location_1.id : "",
              cellLocation2Color: event.location_2.color,
              location2: event.location_2.location_name,
              location_id_2: event.location_2 ? event.location_2.id : "",
              bgColor2: event.location_2
                ? event.location_2.color
                : event.location_1.color,
              bgColor: event.location_1
                ? event.location_1.color
                : event.location_2.color,
              key: `${eventKey}_${event.id}`
            });
          }
          break;
        default:
          break;
      }
    });
  });
  return structure;
};

const renderVehicle = (vehicle, date1, date2) => {
  const structure = buildStructure(
    {
      rentals: vehicle.rentals,
      holds: vehicle.holds,
      transfers: vehicle.transfers
    },
    date1,
    date2
  );
  if (isEmpty(structure)) {
    return "";
  }
  return (
    <Card>
      <Grid container spacing={8}>
        <Grid item xs={12} sm={12}>
          <b>Remaining activity for {vehicle.licence_plate} {vehicle.renting ? "®" : ""}:</b>
        </Grid>
      </Grid>
      <NestedGrid events={sortBy(compose(moment, prop("date1")), structure)} />
    </Card>
  );
};

const VehicleSwitchTitle = object => (
  <span>
    {" Switch Activity for Bike - "} &quot;{object.record.licence_plate} {object.record.renting ? "®" : ""} (
    {object.record.model.model_name})&quot;
  </span>
);

const VehicleHistory = object => {
  return renderVehicle(object.object, object.date1, object.date2);
};

const VehicleToolbar = props => {
  const { invalid } = props;
  return (
    <Toolbar {...props}>
      <SaveButton disabled={invalid} redirect={`/vehicles`} />
    </Toolbar>
  );
};

const isBeforeDate1 = curry((date1, item) =>
  moment(date1).isBefore(moment(item.date_1))
);

const isAfterDate2 = curry((date2, item) =>
  moment(date2).isAfter(moment(item.date_2))
);

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

export const VehicleSwitch = props => {
  let isChanging = false;

  const changeDate = () => {
    isChanging = true;
  };

  const resetValue = e => {
    console.log(e);
    e.target.value = "0";
  };
  return (
    <Edit title={<VehicleSwitchTitle />} {...props}>
      <SimpleForm
        toolbar={<VehicleToolbar props={{ ...props }} />}
        form="myForm"
      >
        <DateInput locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha}
          label="Date Start"
          source="date_start"
          validate={required()}
          onChange={changeDate}
        />
        <DateInput locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha}
          label="Date End"
          source="date_end"
          validate={required()}
          onChange={changeDate}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            if (formData.vehicle_model_id !== undefined) {
              const structure = buildStructure(
                {
                  rentals: formData.rentals,
                  holds: formData.holds,
                  transfers: formData.transfers
                },
                formData.date_start,
                formData.date_end
              );

              const sortedEvents = sortBy(
                compose(moment, prop("date1")),
                structure
              );
              const firstEvent = head(sortedEvents);

              if (!isNil(formData.date_start) && !isNil(formData.date_end)) {
                // if (isEmpty(sortedEvents)) {
                //   return (
                //     <React.Fragment>
                //       <TextInput
                //         onChange={e => resetValue}
                //         source="new_vehicle_id"
                //         validate={required()}
                //       />

                //       <p>No bikes available</p>
                //     </React.Fragment>
                //   );
                // }
                return (
                  <React.Fragment>
                    {!isEmpty(sortedEvents) && (
                      <VehicleHistory
                        object={rest.record}
                        date1={formData.date_start}
                        date2={formData.date_end}
                      />
                    )}
                    {
                      <Query
                        type="GET_LIST"
                        resource="bikes_available_to_switch"
                        payload={{
                          filter: {
                            modelId: formData.vehicle_model_id,
                            vehicleId: formData.id,
                            location:
                              firstEvent.title === "Transfer"
                                ? head(sortedEvents).location_id_2
                                : head(sortedEvents).location_id_1,
                            date1: formData.date_start,
                            date2: formData.date_end
                          },
                          sort: { field: "licence_plate", order: "ASC" },
                          pagination: { page: 1, perPage: 1000 }
                        }}
                      >
                        {({ data, total, loading, error }) => {
                          if (loading || isChanging) {
                            isChanging = false;
                            return <LinearProgress />;
                          }
                          if (error) {
                            return <p>ERROR</p>;
                          }

                          return (
                            <React.Fragment>
                              <SelectInput
                                key={formData.new_vehicle_id}
                                // source="bikes_available_to_switch"
                                label="Available Bike"
                                optionValue="id"
                                source="new_vehicle_id"
                                optionText={vehicle => {
                                  return `${vehicle.licence_plate} ${vehicle.renting ? "®" : ""} (${vehicle.model_name} / ${vehicle.vehicle_color} / ${vehicle.vehicle_mileage} KM)`;
                                }}
                                validate={required()}
                                defaultValue={null}
                                choices={data}
                              />
                              {isEmpty(data) && (
                                <h5>
                                  No bikes available for dates, location and
                                  model
                                </h5>
                              )}

                              {formData.new_vehicle_id && (
                                <Query
                                  type="GET_ONE"
                                  resource="bikes_available_to_switch"
                                  payload={{ id: formData.new_vehicle_id }}
                                >
                                  {({ data, loading }) =>
                                    loading ? (
                                      <LinearProgress />
                                    ) : (
                                      <React.Fragment>
                                        {renderVehicle(
                                          data,
                                          formData.date_start,
                                          formData.date_end
                                        )}
                                      </React.Fragment>
                                    )
                                  }
                                </Query>
                              )}
                            </React.Fragment>
                          );
                        }}
                      </Query>
                    }
                  </React.Fragment>
                );
              }
            }
            return <React.Fragment></React.Fragment>;
          }}
        </FormDataConsumer>
      </SimpleForm>
    </Edit>
  );
};



// WEBPACK FOOTER //
// ./src/resources/vehicleSwitch.js